import { type ReactNode, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';

// ツールの呼び出しを折りたたみ表示するコンポーネント
export function ToolPartToggle({ label, children }: { label: ReactNode; children: ReactNode }) {
  const [state, setState] = useState({
    open: false,
  });

  return (
    <>
      <div className="my-1">
        <button
          aria-expanded={state.open}
          className="inline-flex cursor-pointer items-center gap-1 text-left text-xs text-gray-600 hover:text-gray-700"
          onClick={() => setState((s) => ({ open: !s.open }))}
        >
          {label}
          <FontAwesomeIcon icon={state.open ? faChevronUp : faChevronDown} className="size-2" />
        </button>
      </div>
      {state.open && (
        <div className="max-h-[40vh] overflow-auto whitespace-pre-wrap rounded-md border border-gray-300 bg-white p-3 font-mono text-xs text-gray-600">
          {children}
        </div>
      )}
    </>
  );
}
